import {loginContainer, intlShape, utils} from '@wallaby-ui/core';
import {isEqual} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import AutoLayoutService from 'src/js/lib/auto_layout/auto_layout_service';

import {I18N as SAVABLE_COMPONENT_I18N} from './SavableComponentContainer';
import {changeSelectedScreenId, loadAutoLayout} from '../auto_layout_actions';
import {getCurrentScreenId} from '../auto_layout_selectors';

class AutoLayoutLoaderContainer extends React.Component {
  constructor(props) {
    super(props);
    const {autoLayoutStateId, screenId, contextParams} = this.props;
    const filteredContext = AutoLayoutService.getFilteredContext(contextParams);
    if (screenId) {
      // if screenId is passed in construct time, we need to set selectedScreenId
      // that will transitively change currentScreenId which is used in lifecycle methods,
      // screenId from props is not used anymore
      this.props.changeSelectedScreenId(
        autoLayoutStateId,
        screenId,
        filteredContext
      );
    }
  }

  componentDidMount() {
    const {
      autoLayoutStateId,
      config,
      configStateId,
      contextParams,
      currentContextParams,
      currentScreenId,
      intl,
      isDynamic,
      miniScreensConfig,
    } = this.props;
    const filteredContext = AutoLayoutService.getFilteredContext(contextParams);

    // HANDLE AUTO_LAYOUT LOAD
    // already loaded current context params are different from the wanted one
    if (currentScreenId && !isEqual(filteredContext, currentContextParams)) {
      this.props.loadAutoLayout(
        autoLayoutStateId,
        config,
        configStateId,
        filteredContext,
        isDynamic,
        miniScreensConfig,
        currentScreenId,
        utils.TranslateUtils.translate(SAVABLE_COMPONENT_I18N.ERROR_LOAD, intl)
      );
    }
  }

  componentDidUpdate(prevProps) {
    const {
      autoLayoutStateId,
      config,
      configStateId,
      contextParams,
      currentContextParams,
      currentScreenId,
      intl,
      isDynamic,
      miniScreensConfig,
    } = this.props;
    const filteredContext = AutoLayoutService.getFilteredContext(contextParams);
    const prevFilteredContext = AutoLayoutService.getFilteredContext(
      prevProps.contextParams
    );

    // HANDLE AUTO_LAYOUT LOAD
    // already loaded current context params are different from the wanted one
    // or the wanted one just has changed
    // or current screen id just has changed
    if (
      currentScreenId &&
      ((!isEqual(filteredContext, currentContextParams) &&
        !isEqual(filteredContext, prevFilteredContext)) ||
        !isEqual(currentScreenId, prevProps.currentScreenId))
    ) {
      this.props.loadAutoLayout(
        autoLayoutStateId,
        config,
        configStateId,
        filteredContext,
        isDynamic,
        miniScreensConfig,
        currentScreenId,
        utils.TranslateUtils.translate(SAVABLE_COMPONENT_I18N.ERROR_LOAD, intl)
      );
    }
  }

  render() {
    return null;
  }
}

AutoLayoutLoaderContainer.displayName = 'AutoLayoutLoaderContainer';

AutoLayoutLoaderContainer.propTypes = {
  autoLayoutStateId: PropTypes.string.isRequired,
  config: PropTypes.objectOf(PropTypes.any).isRequired,
  configStateId: PropTypes.string.isRequired,
  contextParams: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: intlShape.isRequired,
  isDynamic: PropTypes.bool,
  screenId: PropTypes.string,
};

AutoLayoutLoaderContainer.defaultProps = {
  isDynamic: false,
  screenId: undefined,
};

export default connect(
  (state, props) => ({
    currentContextParams: state[props.autoLayoutStateId].currentContextParams,
    // currentScreenId is undefined while currentContextParams (used in following selector)
    // is undefined until first load of screen, we need to pass wanted value of contextParams
    // to currentContextParams
    currentScreenId: getCurrentScreenId(state, {
      ...props,
      currentContextParams: props.contextParams,
    }),
    miniScreensConfig: state[props.autoLayoutStateId].miniScreensConfig,
  }),
  {
    changeSelectedScreenId,
    loadAutoLayout,
  }
)(injectIntl(AutoLayoutLoaderContainer));
